import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Admin.css";
import { Routes, Route, Navigate } from "react-router-dom";
import UserFormsList from "../pages/UserSpace/UserFormsList/UserFormsList";
import UserCreatedFormsList from "../pages/UserSpace/UserCreatedFormsList/UserCreatedFormsList";
import UserFormFillPage from "../pages/UserSpace/UserFormFillPage";
import UserCreatedFormFillPage from "../pages/UserSpace/UserCreatedFormFillPage";
import UserExcels from "../pages/UserSpace/UserExcels/UserExcels";
import NotFound from "./404NotFound";
import GenerateForms from "../pages/UserSpace/GenerateForms/GenerateForms";
import UserProfile from "../pages/UserSpace/UserProfile/UserProfile";
import UserFormsetsList from "../pages/FormSets/FormsSets";
import Filters from "../pages/Filters/Filters";

export default function User() {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const location = useLocation();
  const userDataString = localStorage.getItem("userData");
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const isSuperUser = userData?.roles?.some(
    (role) => role.name === "ROLE_SUPERUSER"
  );

  const toggleSidebar = () => {
    setSidebarVisible((prevState) => !prevState);
  };

  const closeSidebar = () => {
    setSidebarVisible(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        closeSidebar();
      }
    };

    // Close sidebar on initial load for mobile
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array for initial mount only

  useEffect(() => {
    if (window.innerWidth <= 768) {
      closeSidebar();
    }
  }, [location.pathname]);

  return (
    <Routes>
      {/* Route for FormFillPage without layout */}
      <Route path="/User-Fill-Form/:formId" element={<UserFormFillPage />} />
      <Route
        path="/User-Created-Form-Fill/:formId"
        element={<UserCreatedFormFillPage />}
      />

      {/* Routes with user-layout */}
      <Route
        path="*"
        element={
          <div
            className={`user-layout ${sidebarVisible ? "sidebar-visible" : ""}`}
          >
            <header>
              <Navbar onSidebarToggle={toggleSidebar} />
            </header>
            <div className="main-content">
              <UserSidebar
                isVisible={sidebarVisible}
                closeSidebar={closeSidebar}
              />
              <div className="content-wrapper">
                <div className="content">
                  <Routes>
                    <Route
                      path="/"
                      element={
                        isSuperUser ? (
                          <Navigate to="/User-Created-Forms-List" />
                        ) : (
                          <Navigate to="/User-Assigned-Forms-List" />
                        )
                      }
                    />
                    <Route
                      path="/User-Created-Forms-List"
                      element={
                        isSuperUser ? (
                          <UserCreatedFormsList />
                        ) : (
                          <Navigate to="/User-Assigned-Forms-List" />
                        )
                      }
                    />
                    <Route
                      path="/User-Assigned-Forms-List"
                      element={<UserFormsList />}
                    />
                    <Route path="/User-Excel" element={<UserExcels />} />
                    <Route path="*" element={<NotFound />} />
                    <Route
                      path="/User-Generate-Form"
                      element={
                        isSuperUser ? (
                          <GenerateForms />
                        ) : (
                          <Navigate to="/User-Assigned-Forms-List" />
                        )
                      }
                    />

                    <Route
                      path="/User-Formsets-List"
                      element={
                        isSuperUser ? (
                          <UserFormsetsList />
                        ) : (
                          <Navigate to="/User-Assigned-Forms-List" />
                        )
                      }
                    />
                    <Route
                      path="/User-Filters-List"
                      element={
                        isSuperUser ? (
                          <Filters />
                        ) : (
                          <Navigate to="/User-Assigned-Forms-List" />
                        )
                      }
                    />
                    <Route path="/Profile" element={<UserProfile />} />
                  </Routes>
                </div>
              </div>
            </div>
            <footer>
              <Footer />
            </footer>
          </div>
        }
      />
    </Routes>
  );
}
